export const semaphoreLocks = state => state.semaphoreLocks.semaphoreLocks;